export default "__VITE_ASSET__3ee9c397__"